import { createAction } from '@ngrx/store';

import { ClaimsFaqFailResponse, ClaimsFaqResponse } from '../models/claim-faq.model';

export enum ClaimFaqActionTypes {
  LOAD_CLAIM_FAQ = '[ClaimFaq] Load Claim Faq',
  LOAD_CLAIM_FAQ_SUCCESS = '[ClaimFaq] Load Claim Faq Success',
  LOAD_CLAIM_FAQ_FAIL = '[ClaimFaq] Load Claim Faq Fail'
}

export const LoadClaimFaq = createAction(ClaimFaqActionTypes.LOAD_CLAIM_FAQ);

export const LoadClaimFaqSuccess = createAction(
  ClaimFaqActionTypes.LOAD_CLAIM_FAQ_SUCCESS,
  (payload: ClaimsFaqResponse) => ({
    payload
  })
);

export const LoadClaimFaqFail = createAction(
  ClaimFaqActionTypes.LOAD_CLAIM_FAQ_FAIL,
  (payload?: ClaimsFaqFailResponse) => ({
    payload
  })
);

export type ClaimFaqAction =
  | ReturnType<typeof LoadClaimFaq>
  | ReturnType<typeof LoadClaimFaqSuccess>
  | ReturnType<typeof LoadClaimFaqFail>;
